import React from "react";
import { X, Maximize2 } from "lucide-react";
import ResultsTable from "./ResultsTable";

/**
 * Full-window modal that shows the results table expanded to ~1100px wide.
 * All columns are visible (no horizontal scroll needed) and larger text.
 */
export default function FullResultsModal({ tracks, onClose, onSelect, queueIds, activeQuery }) {
  return (
    <div
      data-testid="full-results-modal"
      className="fixed inset-0 z-[70] flex items-center justify-center p-4"
      style={{ background: "rgba(0,0,0,0.5)" }}
      onClick={onClose}
    >
      <div
        className="w-[1140px] max-w-[98vw] h-[82vh] ie-chrome flex flex-col overflow-hidden"
        onClick={(e) => e.stopPropagation()}
      >
        {/* XP title bar */}
        <div className="xp-titlebar-blue h-[28px] flex items-center justify-between px-2 select-none">
          <div className="flex items-center gap-2 text-[13px] font-bold">
            <Maximize2 size={13} />
            Search Results {activeQuery ? `— "${activeQuery}"` : ""} &middot; Expanded View
          </div>
          <button
            data-testid="full-results-close"
            onClick={onClose}
            className="w-[22px] h-[19px] rounded-sm bg-gradient-to-b from-[#F58D85] via-[#E81123] to-[#8B0A14] text-white flex items-center justify-center hover:brightness-110"
            aria-label="Close"
          >
            <X size={11} strokeWidth={4} />
          </button>
        </div>

        {/* Menu bar stub for XP vibe */}
        <div className="h-[22px] flex items-center px-2 gap-3 text-[12px] border-b border-[#9C9A7E] bg-[#ECE9D8]">
          <span><u>F</u>ile</span>
          <span><u>E</u>dit</span>
          <span><u>V</u>iew</span>
          <span><u>T</u>ools</span>
          <span><u>H</u>elp</span>
          <span className="ml-auto text-[11px] text-[#555] font-mono">
            {tracks.length} results · click to scan &amp; play
          </span>
        </div>

        {/* Full table */}
        <div className="flex-1 min-h-0 p-2 bg-[#ECE9D8]">
          <ResultsTable
            tracks={tracks}
            loading={false}
            onSelect={(t) => { onSelect(t); }}
            queueIds={queueIds}
            expanded
          />
        </div>

        {/* Footer */}
        <div
          className="px-3 py-1 flex items-center justify-between text-[12px] border-t-2 border-[#808080]"
          style={{ background: "linear-gradient(to bottom, #ECE9D8, #D4D0BF)" }}
        >
          <div className="flex items-center gap-2">
            <span className="led-green" />
            <span>All columns visible · No malware. Just bangers.</span>
          </div>
          <button
            onClick={onClose}
            className="bevel-btn px-5 py-0.5 text-[12px] font-bold"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
}
